import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  ICompany,
  ICompanyListRequest,
  ICompanyCreateRequest,
  ICompanyUpdateRequest,
  CompanyState,
} from "@/types/company";

import CustomRequest from "../customRequest";

const actions: ActionTree<CompanyState, RootState> = {
  async getList({ commit }, params: ICompanyListRequest) {
    await CustomRequest.get<IPagination<ICompany>>({
      uri: "/company",
      params,
      commit,
      target: "pagination",
    });
  },

  async get({ commit }, companyId: number) {
    await CustomRequest.get<ICompany>({
      uri: `company/${companyId}`,
      commit,
      target: "single",
    });
  },

  async update(
    { commit },
    datas: { company_id: number; params: ICompanyUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<ICompany>({
      uri: `company/${datas.company_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async create({ commit }, params: ICompanyCreateRequest) {
    const { error } = await CustomRequest.post<ICompany>({
      uri: `/register`,
      params,
      flash: true,
    });

    return !error;
  },

  async delete({ commit }, company_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/company/${company_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
